import { OtherLocalStorageKey } from ':shared/enums';

export const saveJwtTokenToLocalStorage = (token: string): void => {
    localStorage.setItem(OtherLocalStorageKey.JWT_TOKEN, token);
};

export const getJwtTokenFromLocalStorage = (): string | null => localStorage.getItem(OtherLocalStorageKey.JWT_TOKEN);

export const isJwtTokenInLocalStorage = (): boolean => !!getJwtTokenFromLocalStorage();

export const removeJwtTokenFromLocalStorage = (): void => localStorage.removeItem(OtherLocalStorageKey.JWT_TOKEN);
